import React from "react";
import styles from "./ModalComponent.module.css";
import { Modal } from "antd";
import TextComponent from "../textComponent/TextComponent";
import SubmitButton from "../submitButton/SubmitButton";
const ModalComponent = ({
  open,
  onCancel,
  className,
  icon,
  image,
  imageClass,
  width,
  title,
  headingClass,
  textClass,
  buttonTitle,
  onBtnPress,
  text,
  btnClass,
  twoButton,
  onClickOkButton,
  onClickCancelButton,
  okBtnTitle,
  cancelBtnTitle,
  btnDiv,
  okbtnClass,
  cancelbtnClass,
  children,
  btnStyle,
  leftBtnIcon,
  closable,
  fontFamily,
  SingleButtonClass,
  SinglebtnContainerClass
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={false}
      // width={width ? width : "40%"}
      className={`${className} ${styles.modalCont}`}
      closable={closable ? closable : true}
    //   className=""
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {icon && (
          <div className={`${imageClass} ${styles.imageBox}`}>
            {icon && (
              icon
            ) }
          </div>
        )}
        {title && (
          <TextComponent
            id={"title"}
            text={title}
            className={`${headingClass} ${styles.heading}`}
          />
        )}
        {text && (
          <TextComponent
            text={text}
            className={textClass}
            fontFamily={fontFamily}
          />
        )}
        {children}

        {buttonTitle ? (
          <SubmitButton
            primary
            title={buttonTitle}
            onClick={onBtnPress}
            style={btnStyle ? btnStyle : { width: "90%" }}
          />
        ) : twoButton ? (
          <div className={`${btnDiv} ${styles.btnDiv}`}>
            <SubmitButton
              leftIcon={leftBtnIcon}
              title={okBtnTitle}
              onClick={onClickOkButton}
              primary
              style={btnStyle ? btnStyle : { width: "90%" }}
            />
            <SubmitButton
              secondary
              title={cancelBtnTitle}
              onClick={onClickCancelButton}
              style={btnStyle ? btnStyle : { width: "90%" }}
            />
          </div>
        ) : null}
      </div>
    </Modal>
  );
};

export default ModalComponent;
